<template>
  <div>
    <div class="homePage">
      <div class="left-tag">
        <el-collapse v-model="activeNames">
          <el-collapse-item title="付费短故事" name="1">
            <div class="collapse-item active">全部内容</div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <div class="right-content">
        <div class="right-title">
          <div>全部内容</div>
          <div class="search-box">
            <el-input v-model="searchParams" placeholder="请输入书名/bookid">
              <el-button slot="append" @click="searchByKeywords" icon="el-icon-search"></el-button></el-input>
          </div>
        </div>
        <classify @tagClick="groupOneClick" :classifyInfo="groupOne" />
        <classify @tagClick="groupTwoClick" :classifyInfo="groupTwo" />
        <classify @tagClick="groupThereClick" :classifyInfo="groupThere" />
        <!-- 书架列表 -->
        <div class="bookList">
          <div v-if="bookList.length" class="books">
            <book v-for="(item, index) in bookList" :book-info="item" :key="index" />
          </div>
          <div class="empty" v-else>
            <el-empty description="没有找到该书籍"></el-empty>
          </div>
        </div>
        <div class="pagination">
          <el-pagination ref="paginations" background :page-size="20" layout="prev, pager, next" :total="totalPage" @current-change="currentChange">
          </el-pagination>
        </div>
      </div>



    </div>
    <div class="mobile-home">
      <div class="header-box">
        <div class="nav">
          看点小故事
          <div class="searchbox" @click="toSearchPage">
            <i class="el-icon-search"></i>
          </div>
        </div>
      </div>
      <div class="content-m">
        <div class="left">
          <div class="tags active">全部内容</div>
          <!-- <div class="tags">其他</div> -->
        </div>
        <div class="right">
          <!-- 筛选条件 -->
          <div class="filtrate">
            <div class="fil-left">
              <span  :class="['tags', mobileCurrentIndex == 0 ? 'active' : '']"  @click="mobileFilClock(0,0)">全部</span>
              <span :class="['tags', mobileCurrentIndex == index+1 ? 'active' : '']" v-for="(item, index) in groupTwo" :key="index" @click="mobileFilClock(item.value,index+1)">{{ item.name }}</span>
            </div>
            <div class="fil-right" @click="drawer = true">
              <i class="el-icon-s-open"></i>
              <span>筛选</span>
            </div>
          </div>
          <div class="booklist">
              <div class="books" v-if="bookList.length>0">
                <mobileBook v-for="(item, index) in bookList" :book-info="item" :key="index" />
              </div>
              <div class="empty" v-else>
                <el-empty description="没有找到对应的小说"></el-empty>
              </div>
          </div>
          <div class="pagination">
          <el-pagination ref="pagination" :page-size="20" background :current-page="mobilePage" layout="prev, pager, next" mini  :pager-count="3" :total="totalPage" @current-change="currentChange">
          </el-pagination>
        </div>
        </div>
      </div>
    </div>
    <myDrawer :drawer="drawer" @comfirm="comfirm" :groupOne="groupOne" :groupTwo="groupTwo" :groupThere="groupThere" />
  </div>
</template>
<script>
import { getBookList } from '../../api/index'
import classify from './cpns/Classify.vue'
import book from './cpns/Book.vue'
import myDrawer from './cpns/myDrawer.vue'
import mobileBook from './cpns/mobileBook.vue'
export default {
  components: {
    classify,
    book,
    myDrawer,
    mobileBook
  },
  data() {
    return {
      activeNames: ['1'],
      groupOne: [{ name: '男频', value: '1' }, { name: '女频', value: '2' }],
      groupTwo: [{name:'现代言情',value:'87,88,89,90,91,92,93,94,120'},{name:'古代言情',value:'82,83,84,85,86,119'},{name:'现实情感',value:'95,96,97,98,99,121,122,123,124'},{name:'都市小说',value:'54,55,56,57'},{name:'奇闻异事',value:'24,25,26,102'},{name:'男频性转',value:'104,105,106,107,108,109'}, { name: '现言虐恋', value: '93' }, { name: '现言甜宠', value: '94' }, { name: '现言爽文', value: '120' }, { name: '古言虐恋', value: '85' }, { name: '古言甜宠', value: '86' }, { name: '古言爽文', value: '119' },{ name: '家庭伦理', value: '95' }, { name: '情感复仇', value: '97' }, { name: '婚姻生活', value: '96' }, { name: '世情故事', value: '98' }, { name: '世情爽文', value: '121' }, { name: '打脸爽文', value: '123' }, { name: '复仇爽文', value: '124' }, { name: '穿越重生', value: '92' }, { name: '娱乐明星', value: '91' }, { name: '都市生活', value: '87' }, { name: '青春校园', value: '88' }, { name: '宅斗宫斗', value: '82' }, { name: '权谋之争', value: '84' }, { name: '生活悬疑', value: '58' }, { name: '民俗悬疑', value: '110' }],
      groupThere: [{ name: '近一天', value: '1' }, { name: '近5天', value: '2' }, { name: '近10天', value: '3' }, { name: '一个月以内', value: '4' }, { name: '一个月以上', value: '5' }],
      //频道分类
      mobileCurrentIndex:0,
      drawer: false,
      searchParams: '',
      searchBtn: '书名',
      searchQuery: {
        // channel_type:1,
        category_ids: 0,
        search_time: 0,
        page: 1,
        page_size: 20,
        search_keywords: ''
      },
      bookList: [],
      totalPage: 0,
      mobilePage:1
    }
  },
  created() {


    this.getBookList(this.searchQuery)

  },
  methods: {
    //获取书籍列表
    async getBookList(data) {


      const res = await getBookList(data)
      if (res) {
        this.bookList = res.data.data
        this.totalPage = parseInt(res.data.page_info.total)
      }

    },
    groupOneClick(e) {
      if (e == -1) {
        if (Object.prototype.hasOwnProperty.call(this.searchQuery, 'channel_type')) {
          delete this.searchQuery.channel_type
        }
      } else {
        this.searchQuery.channel_type = e
      }
      this.pageToOne()
      this.getBookList(this.searchQuery)
    },
    mobileFilClock(e,current){
      this.pageToOne()
      this.searchQuery.category_ids = e
      this.mobileCurrentIndex = current
      this.getBookList(this.searchQuery)
    },
    groupTwoClick(e) {
      if (e == -1) {
        this.searchQuery.category_ids = 0
      } else {
        this.searchQuery.category_ids = e
      }
      this.$nextTick(()=>{
        this.$refs.paginations.internalCurrentPage = 1
      })
      console.log(e)
      this.searchQuery.page=  1
      this.getBookList(this.searchQuery)
    },
    groupThereClick(e) {
      if (e == -1) {
        this.searchQuery.search_time = 0
      } else {

        this.searchQuery.search_time = e
      }
      this.pageToOne()
      this.getBookList(this.searchQuery)
    },
    comfirm(e) {
      this.drawer = false
      if(parseInt(e[0])==0){
        if (Object.prototype.hasOwnProperty.call(this.searchQuery, 'channel_type')) {
          delete this.searchQuery.channel_type
        }
      }else {
        this.searchQuery.channel_type = parseInt(e[0])
      }
      
      this.pageToOne()
      this.searchQuery.category_ids = parseInt(e[1])
      this.searchQuery.search_time = parseInt(e[2])
      this.getBookList(this.searchQuery)
    },
    pageToOne(){
      this.searchQuery.page = 1
      this.$nextTick(() => {
        this.$refs.paginations.internalCurrentPage = 1
          this.$refs.pagination.internalCurrentPage = 1
      })
    },
    //页码发生改变
    currentChange(e) {
      this.searchQuery.page = e
      this.getBookList(this.searchQuery)
    },
    toSearchPage(){
      this.$router.push('/search')
    },
    //点击搜索按钮pc
    searchByKeywords() {
      this.searchQuery.search_keywords = this.searchParams
      this.getBookList(this.searchQuery)
    }
  }
}
</script >
<style lang="scss" scoped> 
 @media screen and (min-width:1079px) {
    .homePage {
      width: 1079px;
      margin: 0 auto;
      display: flex;
      padding: 50px 0;

      .left-tag {
        box-sizing: border-box;
        margin-right: 12px;
        padding: 12px;
        width: 176px;
        height: auto;
        background: #fff;
        border-radius: 10px;
        align-self: flex-start;

        .collapse-item {
          border-radius: 10px;
          padding: 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
        }

        .active {
          background: rgba(255, 95, 0, .08);
          color: rgb(255, 95, 0);
        }

        ::v-deep .el-collapse-item__header {
          font-size: 16px;
          color: #000;
        }

        ::v-deep .el-collapse-item__content {
          padding-bottom: 5px;
        }
      }

      .right-content {
        flex: 1;
        border-radius: 10px;
        background: #fff;
        padding: 32px;

        .right-title {
          font-size: 20px;
          font-weight: 500;
          margin-bottom: 24px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .search-box {
            display: flex;
          }

          ::v-deep .el-input__inner {
            border-color: #409eff;
          }
        }


        .bookList {

          min-width: 500px;

          .books {
            display: flex;
            flex-wrap: wrap;
            margin-top: 20px;
          }

          .empty {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .pagination {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    .mobile-home {
      display: none;
    }
  }

  @media screen and (max-width:1079px) {

    .left-tag {
      display: none;
    }

    .right-content {
      display: none;
    }

    .mobile-home {
      width: 100%;
      display: block;
      width: 100%;
      padding: 0;

      .header-box {
        position: fixed;
        width: 100%;
        height: 40px;
        top: 0;
        display: flex;
        padding: 0 15px;

        border-bottom: 1px solid rgba(0, 0, 0, .08);

        .nav {
          width: 100%;
          height: 40px;
          position: relative;
          text-align: center;
          line-height: 40px;

          .searchbox {
            position: absolute;
            right: 20px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }

      .content-m {
        width: 100%;
        height: calc(100vh - 40px);
        margin-top: 40px;
        display: flex;

        .left {
          width: 70px;
          border-right: 1px solid rgba(0, 0, 0, .08);

          .tags {
            width: 100%;
            padding: 10px 0;
            font-size: 12px;
            color: rgba(0, 0, 0, .4);
            text-align: center;
          }

          .active {
            color: #000;
          }
        }

        .right {
          flex: 1;
          height: 100%;
          overflow: scroll;
          padding: 0 15px;

          .filtrate {
            display: flex;
            align-items: center;

            .fil-left {
              display: flex;
              align-items: center;
              flex-wrap: nowrap;
              width: 80%;
              height: 30px;
              overflow-x: scroll;
              text-orientation: upright;
              /* 设置文字方向为直立 */
              white-space: nowrap;
              ::-webkit-scrollbar {
               display: none;
              }
              /* 禁止文字换行 */
              .tags {
                padding: 2px 5px;
                margin-left: 8px;
                font-size: 12px;
                color: rgba(0, 0, 0, .4);

                &:first-child {
                  margin-left: 0;
                }
              }

              .active {
                color: #000;
                font-size: 14px;
              }
            }
            ::-webkit-scrollbar {
      display: none;
    }
            .fil-right {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;

            }
          }

          .booklist {}

          .pagination {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 10px 0;
          }
        }
      }
    }

    ::v-deep .el-drawer__open .el-drawer.btt {
      border-radius: 20px 20px 0 0;
    }
  }
</style>
  